namespace advisorop.components.common {

    class VwAccountHeaderController 
    {
        account: domains.IAccount;
        boAccounts: Array<domains.IBOAccount>;
        ppParams: { pplevel: string, ppclientid: string }; // backOfficeEntityId: 4918    U-DEMO04   DEMO01 | backOfficeLevel:  HH CG AC

        static $inject = ["advisorService", "$scope", "advisorDashboardService"];
        constructor(private advisorService: services.AdvisorService,
            private $scope: ng.IScope,
            private advisorDashboardService: services.AdvisorDashboardService) {           
        }

        openPPReport(report: string): void {
            this.advisorDashboardService.calculateBackOfficeParamsAsync("A", `${this.boAccounts[0].accountId}`)
                .then(params => {
                    this.advisorDashboardService.openBackOfficeReport(report, params);
            });
        }
        
        $onInit(): void {              // when account is changed we need to calculate PpLevel and PpClientId, which we needs for a PP reports
            //this.backOfficeParams = this.ads.calculateBackOfficeParams("A", null, item.boAccountIdentifierString, item.boUMAAccountIdentifierString);
            //console.log(this.account);
        }    

        $onChanges(evt) {
        }
    }


    class VwAccountHeader implements ng.IComponentOptions
    {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.controller = VwAccountHeaderController;
            this.controllerAs = "vm";
            this.bindings = {
                account: "<",
                boAccounts: "<"
            };
            this.templateUrl = "spa/shared/common/vw-account-header.html";
        }

    }
    angular.module(Constants.APP).component("vwAccountHeader", new VwAccountHeader());


}